<style lang="scss" scoped>
.state-page {
  margin-top: 100px;
}

</style>
<style lang="scss">
/* stylelint-disable no-duplicate-selectors */
.state-page {
  &__content {
    .icon {
      font-size: 64px;
    }

    &.special {
      .icon {
        font-size: 168px;
      }
    }
  }
}

</style>
<template>
    <div class="state-page">
        <plugin-mold
            :type="'difficulty'"
            class="state-page__content"
            :class="{ 'special': type === 'success'}"
            :icon="currentInfor.icon"
            :msg="currentInfor.msg"
            :btnMsg="currentInfor.btnMsg"
            :title="currentInfor.title"
            :btnRound="false"
            :btnType="type === 'success' ? 'default' : 'primary'"></plugin-mold>
    </div>
</template>
<script>
export default {
  name: 'pageState',
  created() {
    this.type = this.$route.params.type;
  },
  data() {
    return {
      type: '',
    };
  },
  computed: {
    currentInfor() {
      return this.data[this.type];
    },
    data() {
      return {
        success: {
          // icon: 'icon-xiugaichenggong_xingzhuang',
          icon: 'https://cdncc-frontend.caocaokeji.cn/2/oa/images/gap-web-passpord/success.png',
          title: this.$t('state.success'),
          msg: this.$t('state.successMsg'),
          btnMsg: this.$t('state.finish'),
        },
        warning: {
          // icon: 'icon-jinggao_xingzhuang',
          icon: 'https://cdncc-frontend.caocaokeji.cn/2/oa/images/gap-web-passpord/error.png',
          title: this.$t('state.warning'),
          msg: this.$t('state.warningMsg'),
          btnMsg: this.$t('state.back'),
        },
        error: {
          // icon: 'icon-xiugaicuowu_xingzhuang',
          icon: 'https://cdncc-frontend.caocaokeji.cn/2/oa/images/gap-web-passpord/error.png',
          title: this.$t('state.error'),
          msg: this.$t('state.errorMsg'),
          btnMsg: this.$t('state.back'),
        },
      };
    },
  },
};

</script>
